import { render, staticRenderFns } from "./RobotItem.vue?vue&type=template&id=e37770ee&"
import script from "./RobotItem.vue?vue&type=script&lang=js&"
export * from "./RobotItem.vue?vue&type=script&lang=js&"
import style0 from "./RobotItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports